import { isOneBrand } from "Foundation/Configurations/GlobalConfiguration";

export default function PLFooterLinks() {
  return (
    <>
      <div>
        <a
          rel="noopener noreferrer"
          href="https://www.libertymutualgroup.com/about-lm/corporate-information/privacy-policy"
          target="_blank"
          title="Liberty Mutual Privacy Policy"
        >
          Privacy policy
        </a>
        &nbsp;|&nbsp;
      </div>
      <div>
        <a
          rel="noopener noreferrer"
          href="https://libertymutualgroup.com/about-lm/corporate-information/security-policy"
          target="_blank"
          title="Liberty Mutual Security Policy"
        >
          Security policy
        </a>
        &nbsp;|&nbsp;
      </div>
      <div>
        <a
          rel="noopener noreferrer"
          href="https://now.agent.safeco.com/terms-of-use"
          target="_blank"
          title="View this site's terms of use"
        >
          Terms of use
        </a>
        &nbsp;|&nbsp;
      </div>
      <div>
        <a
          rel="noopener noreferrer"
          href="https://www.libertymutualgroup.com/about-lm/our-company/terms-and-conditions"
          target="_blank"
          title="View this site's terms and conditions"
        >
          Terms and conditions
        </a>
        &nbsp;|&nbsp;
      </div>
      <div>
        <a
          rel="noopener noreferrer"
          href="https://libertymutualgroup.com/about-lm/corporate-information/fraud-protection-tips"
          target="_blank"
          title="Help"
        >
          Fraud Protection
        </a>
        &nbsp;|&nbsp;
      </div>
      <div>
        <a rel="noopener noreferrer" href="https://www.libertymutualgroup.com" title="Supplemental Agreement">
          Supplemental Agreement
        </a>
      </div>
    </>
  );
}
